
angular.module('impactx.deliverynote').controller('SaveDeliveryNoteAndCloseCtrl', SaveDeliveryNoteAndCloseCtrl);

SaveDeliveryNoteAndCloseCtrl.$inject = ['dataGen', 'parent', '$scope', '$mdDialog', '$mdToast', 'OutsourcedCommentSaveService', 'fromReadOnly', 'checkResult', 'AppConfiguration'];

function SaveDeliveryNoteAndCloseCtrl(dataGen, parent, $scope, $mdDialog, $mdToast, OutsourcedCommentSaveService, fromReadOnly, checkResult, AppConfiguration)
{
    $scope.autoAccept = AppConfiguration.get("autoAcceptDeliveryNote");
    $scope.acceptPartialDelivery = {value: 1};
    $scope.acceptOverShipment = {value: 1};
    $scope.acceptOthers = {value: 1};

    $scope.partialDeliveryAllowed = $scope.autoAccept || parent.data.dnh.partialDeliveryAllowed;
    $scope.overshipmentAllowed = $scope.autoAccept || parent.data.dnh.overshipmentAllowed;
    if (checkResult) {
        $scope.trns = checkResult.trns;
        $scope.data = checkResult.data;
        if ($scope.data){
            $scope.acceptOthers.value = $scope.autoAccept || $scope.data.defaultAcceptOthers ? 1 : 2; // no errors, chose next step
        }
    }

    $scope.closeFunction = function (followCphId) {
        $scope.hide({checkItems: $scope.autoAccept || $scope.acceptOthers.value === 1,
            needsAllItems: !$scope.autoAccept && $scope.acceptOthers.value === 2,
            followCphId: followCphId
        });
        $mdToast.show(
            $mdToast.simple()
                .textContent(parent.trns.SaveSuccess)
                .position("bottom right")
                .hideDelay(10000)
        );
    };

    $scope.saveAndCloseDeliveryNote = function ()
    {
        var extractedComments = OutsourcedCommentSaveService.extractComments(parent.data.dnh);

        parent.data.dnh.acceptPartialDelivery = $scope.autoAccept || ($scope.data.hasPartialDelivery && $scope.acceptPartialDelivery.value === 1 && $scope.partialDeliveryAllowed);
        parent.data.dnh.acceptOverShipment = $scope.autoAccept || ($scope.data.hasOvershipment && $scope.acceptOverShipment.value === 1 && $scope.overshipmentAllowed);
        parent.data.dnh.acceptOthers = $scope.autoAccept || $scope.acceptOthers.value === 1;
        parent.data.dnh.hasErrors = $scope.data.hasErrors;
        var dataObj = {
            data: parent.data,
            fromReadOnly: fromReadOnly,
            skippedErrors: parent.skipErrors
        };
        dataGen.post(parent, dataObj, "/deliverynote/saveAndClose").then(function (data)
        {
            parent.clearSkippedErrors();
            if (data && data.data && data.data.commentData)
            {
                OutsourcedCommentSaveService.saveComments(data.data.commentData, extractedComments).then(function(){
                    $scope.closeFunction(data.data.dnh ? data.data.dnh.followCphId : -1);
                });
            }
            else
            {
                $scope.closeFunction(data && data.data && data.data.dnh ? data.data.dnh.followCphId : -1);
            }
        }, function (data) {
            OutsourcedCommentSaveService.restoreComments(parent.data.dnh, extractedComments);
            parent.handleSkippableErrors(data);
        });
    };
    $scope.hide = function (followProcess)
    {
        $mdDialog.hide(followProcess);
    };
}